import React, {useEffect, useState} from 'react'
import {Blacked} from "../../../../CRM/components/styles";
import {ReactComponent as ModalCloseIcon} from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import styled from "styled-components";
import {MEDIA_URL} from "../../../../app/constants/APIKEYS";
import {useAgentSaleInfo} from "../../../hooks/Agent/SaleProperty/GetAgentSaleInfo";


const PRIMARY_HEX = "#3A77F2";
const ACCENT_HEX  = "#58B2FF";
const BG_1 = "#F5F8FE";
const BG_2 = "#ECF3FF";
const TEXT_MAIN = "#0B1B2E";
const TEXT_SUB  = "#2C4159";
const CARD_BG   = "rgba(255,255,255,0.96)";
const CARD_BORDER = "#E6ECF5";
const SHADOW = "0 12px 40px rgba(18, 45, 90, 0.12)";
const DEFAULT_TITLE_COLOR = '#6B21A8';

const resolveTransactionColor = (transactionType?: string): string => {
  if (!transactionType) return DEFAULT_TITLE_COLOR;
  if (transactionType.includes('전세')) return '#EF4444';
  if (transactionType.includes('매매')) return '#07bc0c';
  if (transactionType.includes('월세')) return '#003aff';
  return DEFAULT_TITLE_COLOR;
};



function useNow(interval = 1000) {
  const [now, setNow] = useState<Date>(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), interval); return () => clearInterval(t); }, [interval]);
  return now;
}
function formatTime(d: Date) {
  const hh = d.getHours().toString().padStart(2, "0");
  const mm = d.getMinutes().toString().padStart(2, "0");
  return `${hh}:${mm}`;
}
function formatDate(d: Date) {
  const y = d.getFullYear();
  const m = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  const weekday = ["일","월","화","수","목","금","토"][d.getDay()];
  return `${y}.${m}.${day} (${weekday})`;
}

export const SalePreviewMonitor = ({setIsPreviewModal, itemId, agentSaleItem}) => {
  // const [selectedItem, setSelectedItem] = React.useState<any>({});
  const [titleColor, setTitleColor] = useState<string>(DEFAULT_TITLE_COLOR);
  const {agentSaleInfo} = useAgentSaleInfo(itemId);

  // useEffect(() => {
  //   console.log('agentSaleList', agentSaleList);
  //   setSelectedItem(agentSaleList.find((item) => itemId === item.adId));
  // }, [agentSaleList]);


  useEffect(() => {
    console.log('agentSaleInfo', agentSaleInfo);
    const current = itemId ? agentSaleInfo : agentSaleItem;
    setTitleColor(resolveTransactionColor(current?.transactionType));
  }, [agentSaleInfo, agentSaleItem, itemId]);

  const now = useNow(1000);


  return (
      <>
        <Blacked onClick={() => setIsPreviewModal(false)}/>
        <ModalWrapper className={"scroll-container"}>
          <ModalHeader>
            <ModalTitle>미리보기</ModalTitle>
            <CloseIconSVG as={ModalCloseIcon} onClick={() => {
              setIsPreviewModal(false)
            }}/>
          </ModalHeader>

          <Contents>
            <MonitorTitle>전면</MonitorTitle>
            {itemId ?
                <div>
                  <MonitorWrapper style={{display: 'flex'}}>
                    <FullImg src={agentSaleInfo?.fileList && MEDIA_URL + agentSaleInfo?.fileList[0]?.url}/>
                    <SaleWrapper>
                      <SaleTitle>{`${agentSaleInfo?.type || ''}`}
                        <SaleTitleColor style={{
                          backgroundColor: titleColor,
                        }}>{agentSaleInfo?.transactionType || ''}</SaleTitleColor>
                      </SaleTitle>
                      <SalePrice>{`${agentSaleInfo?.price || ''}`}</SalePrice>
                      <SaleAddress>{`${agentSaleInfo?.address || ''}`}</SaleAddress>
                      <SaleSize>{`${agentSaleInfo?.size || ''}`}</SaleSize>
                      <SaleDescription>{`${agentSaleInfo?.desc || ''}`}</SaleDescription>
                    </SaleWrapper>
                  </MonitorWrapper>
                </div>
                :
                <MonitorWrapper style={{display: 'flex'}}>
                  <FullImg src={agentSaleItem?.fileList && MEDIA_URL + agentSaleItem?.fileList[0]?.url}/>
                  <SaleWrapper>
                    <SaleTitle>{`${agentSaleItem?.type || ''}`}
                      <SaleTitleColor style={{
                        backgroundColor: titleColor,
                      }}>{agentSaleItem?.transactionType || ''}</SaleTitleColor>
                    </SaleTitle>
                    <SalePrice>{`${agentSaleItem?.price || ''}`}</SalePrice>
                    <SaleAddress>{`${agentSaleItem?.address || ''}`}</SaleAddress>
                    <SaleSize>{`${agentSaleItem?.size || ''}`}</SaleSize>
                    <SaleDescription>{`${agentSaleItem?.desc || ''}`}</SaleDescription>
                  </SaleWrapper>
                </MonitorWrapper>
            }
          </Contents>

          <Contents>
            <MonitorTitle>2면</MonitorTitle>
            <MonitorWrapper style={{padding: 4}}>
              <div style={{display: "flex", justifyContent: "center", gap: 6}}>
                {itemId ?
                    <div style={{display: "flex", border: '1px solid black', width: '198px'}}>
                      {/*<TwoBigImg src={agentSaleInfo?.fileList && MEDIA_URL + agentSaleInfo?.fileList[0]?.url}/>*/}
                      <TwoSaleWrapper>
                        <TwoSaleTitle>
                          <span style={{lineHeight: '1'}}>{`${agentSaleInfo?.type || ''}`}</span>
                          <SaleTwoTitleColor style={{
                            backgroundColor: titleColor,
                          }}>{agentSaleInfo?.transactionType || ''}</SaleTwoTitleColor>
                        </TwoSaleTitle>
                        <TwoSalePrice>{`${agentSaleInfo?.price || ''}`}</TwoSalePrice>
                        <TwoSaleAddress>{`${agentSaleInfo?.address || ''}`}</TwoSaleAddress>
                        <TwoSaleSize>{`${agentSaleInfo?.size || ''}`}</TwoSaleSize>
                        <TwoSaleDescription>{`${agentSaleInfo?.desc || ''}`}</TwoSaleDescription>
                      </TwoSaleWrapper>
                    </div>
                    :
                    <div style={{display: "flex", border: '1px solid black', width: '198px'}}>
                      {/*<TwoBigImg src={agentSaleItem?.fileList && MEDIA_URL + agentSaleItem?.fileList[0]?.url}/>*/}
                      <TwoSaleWrapper>
                        <TwoSaleTitle>
                          <span style={{lineHeight: '1'}}>{`${agentSaleItem?.type || ''}`}</span>
                          <SaleTwoTitleColor style={{
                            backgroundColor: titleColor
                          }}>{agentSaleItem?.transactionType || ''}</SaleTwoTitleColor>
                        </TwoSaleTitle>
                        <TwoSalePrice>{`${agentSaleItem?.price || ''}`}</TwoSalePrice>
                        <TwoSaleAddress>{`${agentSaleItem?.address || ''}`}</TwoSaleAddress>
                        <TwoSaleSize>{`${agentSaleItem?.size || ''}`}</TwoSaleSize>
                        <TwoSaleDescription>{`${agentSaleItem?.desc || ''}`}</TwoSaleDescription>
                      </TwoSaleWrapper>
                    </div>
                }
                <TwoBig/>
              </div>

              <div style={{display: "flex", justifyContent: "center", gap: 5, marginTop: 5}}>
                <TwoSmall/>
                <TwoSmall/>
                <TwoSmall/>
                <TwoSmall/>
              </div>
            </MonitorWrapper>
          </Contents>

          <Contents>
            <MonitorTitle>6면</MonitorTitle>
            <MonitorWrapper style={{padding: 4}}>
              <div style={{display: "flex", justifyContent: "center", gap: 3}}>
                {itemId ?
                    <SixSaleWrapper>
                      <SixSaleTitle>
                        <span style={{lineHeight: '1'}}>{`${agentSaleInfo?.type || ''}`}</span>
                        <SaleSixTitleColor style={{
                      backgroundColor: titleColor
                    }}>{agentSaleInfo?.transactionType || ''}</SaleSixTitleColor>
                      </SixSaleTitle>
                      <SixSalePrice>{`${agentSaleInfo?.price || ''}`}</SixSalePrice>
                      <SixSaleAddress>{`${agentSaleInfo?.address || ''}`}</SixSaleAddress>
                      <SixSaleSize>{`${agentSaleInfo?.size || ''}`}</SixSaleSize>
                    </SixSaleWrapper>
                    :
                    <SixSaleWrapper>
                      <SixSaleTitle>
                        <span style={{lineHeight: '1'}}>{`${agentSaleItem?.type || ''}`}</span>
                        <SaleSixTitleColor style={{
                          backgroundColor: titleColor
                        }}>{agentSaleItem?.transactionType || ''}</SaleSixTitleColor>
                      </SixSaleTitle>
                      <SixSalePrice>{`${agentSaleItem?.price || ''}`}</SixSalePrice>
                      <SixSaleAddress>{`${agentSaleItem?.address || ''}`}</SixSaleAddress>
                      <SixSaleSize>{`${agentSaleItem?.size || ''}`}</SixSaleSize>
                    </SixSaleWrapper>
                }
                <SixBox />
                <SixBox />
              </div>

              <div style={{display: "flex", justifyContent: "center", gap: 3, marginTop: 3}}>
                <SixBox />
                <SixBox />
                <SixBox />
              </div>
            </MonitorWrapper>
          </Contents>

        </ModalWrapper>
      </>
  )
}

const TopHUD = styled.div`
  position: absolute; top: 14px; left: 14px; right: 14px; height: 96px;
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 22px;
`;
const Brand = styled.div` display: flex; align-items: baseline; gap: 12px; `;
const BrandName = styled.div` font-size: 34px; font-weight: 900; color: ${TEXT_MAIN}; letter-spacing: 0.2px; `;
const BrandSub  = styled.div` font-size: 20px; font-weight: 700; color: ${TEXT_SUB}; `;
const Clock = styled.div` display: flex; flex-direction: column; align-items: end; gap: 14px; `;
const ClockTime = styled.div` font-size: 20px; font-weight: 900; color: ${TEXT_SUB}; `;
const ClockDate = styled.div` font-size: 30px; font-weight: 700; color: ${TEXT_MAIN}; `;



const ModalWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 820px;
    width: 580px;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
`

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`

const CloseIconSVG = styled.svg`
    width: 24px;
    cursor: pointer;
`

const ModalTitle = styled.div`
    font-family: Pretendard, sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.48px;
    color: #2E2559;
`

const Contents = styled.div`
    margin-top: 45px;
    font-weight: 400;
    font-size: 15px;
    line-height: 17.9px;
    font-family: Pretendard, sans-serif;
    color: #000000;
    white-space: pre-wrap;
    text-align: center;
`

const MonitorTitle = styled.div`
    font-weight: 600;
    font-size: 15px;
    line-height: 17.9px;
    font-family: pretendard, sans-serif;
    margin-bottom: 10px;
`

const MonitorWrapper = styled.div`
    border: 12.87px solid #000000;
    width: 437.61px;
    height: 257.42px;
    
`

const FullImg = styled.img`
    background-color: #D9D9D9;
    width: 50%;
    height: 100%;
`

const SaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
`

const SaleTitle = styled.div`
    font-size: 16px;
    margin-bottom: 15px;
    display: flex;
  align-items: center;
`

const SaleTitleColor = styled.div`
    color: #FFF;
    border-radius: 50px;
    padding: 0.1rem 0.3rem;
    font-size: 10px;
`

const SaleTwoTitleColor = styled.div`
    color: #FFF;
    border-radius: 50px;
    padding: 0.2rem 0.3rem;
    font-size: 5px;
  line-height: 1;
`

const SaleSixTitleColor = styled.div`
    color: #FFF;
    border-radius: 10px;
    padding: 0.1rem 0.2rem;
    font-size: 5px;
    line-height: 1;

`


const SalePrice = styled.div`
    font-size: 19px;
    margin-bottom: 15px;
    background-color: #FACC15;
    color: #000;
    padding: 0.5rem;
  border-radius: 4px;
  font-weight: 800;
`

const SaleAddress = styled.div`
    font-size: 12px;
    margin-bottom: 4px;
    font-weight: 600;
`

const SaleSize = styled.div`
    font-size: 12px;
    margin-bottom: 10px;
  font-weight: 600;
`

const SaleDescription = styled.div`
    font-size: 10px;
    margin-bottom: 4px;
    white-space: pre-wrap;
  color: #4B5563;
  font-weight: 600;
  line-height: 1.4;
`



const TwoBigImg = styled.img`
    background-color: #D9D9D9;
    width: 50%;
    height: 142.01px;
`


const TwoSaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`

const TwoSaleTitle = styled.div`
    font-size: 7px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
`

const TwoSalePrice = styled.div`
    font-size: 10px;
    margin-bottom: 5px;
  background-color: #FACC15;
  color: #000;
  padding: 0.2rem;
  border-radius: 4px;
  font-weight: 800;
`

const TwoSaleAddress = styled.div`
    font-size: 7px;
  font-weight: 600;
`

const TwoSaleSize = styled.div`
    font-size: 7px;
    margin-bottom: 5px;
  line-height: 1.5;
  font-weight: 600;
`

const TwoSaleDescription = styled.div`
    font-size: 5px;
    line-height: 7px;
    white-space: pre-wrap;
  color: #4B5563;
`






const TwoBig = styled.div`
    background-color: #D9D9D9;
    width: 198px;
    height: 142.01px;
`

const TwoSmall = styled.img`
    background-color: #D9D9D9;
    width: 96.96px;
    height: 77.01px;
`

const SixImg = styled.img`
    background-color: #D9D9D9;
    width: 133px;
    height: 111.55px;
`

const SixBox = styled.div`
    background-color: #D9D9D9;
    width: 133px;
    height: 111.55px;
`


const SixSaleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 133px;
    border: black 1px solid;
`

const SixSaleTitle = styled.div`
    font-size: 9px;
    display: flex;
    align-items: center;
  margin-bottom: 4px;
`

const SixSalePrice = styled.div`
    font-size: 10px;
  background-color: #FACC15;
  color: #000;
  padding: 0.1rem;
  border-radius: 4px;
  font-weight: 800;
`

const SixSaleAddress = styled.div`
    font-size: 7px;
  font-weight: 600;
`

const SixSaleSize = styled.div`
    font-size: 7px;
  line-height: 1.3;
  font-weight: 600;
`

const SixSaleDescription = styled.div`
    font-size: 4px;
    line-height: 6px;
    white-space: pre-wrap;
  color: #4B5563;
`
